import { COLORS } from "../utils/colors";

export default function Status({ status, shorten }) {
  return (
    <div
      style={{
        backgroundColor:
          (status == "400" && COLORS.lightOrange) ||
          (status == "404" && COLORS.lightOrange) ||
          (status == "500" && COLORS.lightRed) ||
          (status == "invalid" && COLORS.lightRed) ||
          (status == "refunded" && COLORS.lightRed) ||
          (status == "canceled" && COLORS.lightRed) ||
          COLORS.lightGreen,
        color:
          (status == "400" && COLORS.orange) ||
          (status == "404" && COLORS.orange) ||
          (status == "500" && COLORS.red) ||
          (status == "invalid" && COLORS.red) ||
          (status == "refunded" && COLORS.red) ||
          (status == "canceled" && COLORS.red) ||
          COLORS.green,
        width: "fit-content",
        padding: "5px 10px",
        borderRadius: "5px",
        fontWeight: "bold",
        alignSelf: "center",
      }}
    >
      {shorten ? status?.slice(0, 1) || "ok" : status || "ok"}
    </div>
  );
}
